// extracted by mini-css-extract-plugin
export default {"tutorialVersionSelector":"tutorialVersionSelector--1Psa7"};